import React from 'react';
import SalesTable from '@components/common/Table/SalesTable';

const Sales = ({ 
  getMonthlyFinanceList, 
  monthlyFinanceList, 
  monthlyFinanceListTotal,
  monthlyFinanceListTotalAmount,
  projectName, 
  companyName, 
  setProjectName, 
  setCompanyName,
  page,
  setPage,
  limit,
  setLimit,
  orderBy,
  setOrderBy,
  orderDir,
  setOrderDir
}) => {
  return <SalesTable 
    getMonthlyFinanceList={getMonthlyFinanceList} 
    monthlyFinanceList={monthlyFinanceList} 
    monthlyFinanceListTotal={monthlyFinanceListTotal}
    monthlyFinanceListTotalAmount={monthlyFinanceListTotalAmount}
    projectName={projectName} 
    companyName={companyName} 
    setProjectName={setProjectName} 
    setCompanyName={setCompanyName} 
    page={page} 
    setPage={setPage} 
    limit={limit} 
    setLimit={setLimit} 
    orderBy={orderBy}
    setOrderBy={setOrderBy}
    orderDir={orderDir}
    setOrderDir={setOrderDir}
  />;
};

export default Sales;
